var map = {
	"./account.png": 25814,
	"./account_icon.png": 76256,
	"./after_service.png": 69701,
	"./after_service_active.png": 33208,
	"./agreement_data.png": 29840,
	"./agreement_icon.png": 15551,
	"./agreement_item_bg.png": 98499,
	"./agreement_moreScene.png": 98055,
	"./agreement_points.png": 27997,
	"./agreement_print.png": 40871,
	"./custom_service.png": 37278,
	"./custom_service_icon.png": 89048,
	"./customer_case_bg.png": 44220,
	"./customer_case_main.png": 12082,
	"./data_manage.png": 86617,
	"./data_manage_icon.png": 64973,
	"./goods_manage.png": 9643,
	"./goods_manage_icon.png": 12531,
	"./haiboLong.png": 66694,
	"./new_training.png": 84172,
	"./new_training_active.png": 90123,
	"./partner_list.png": 56710,
	"./rx_service.png": 88613,
	"./rx_service_active.png": 38168,
	"./sale_manage.png": 57826,
	"./sale_manage_icon.png": 60607,
	"./supermarket_pain_point.png": 77144,
	"./supermarket_rx_bg.png": 83987,
	"./verfication.png": 62269,
	"./verfication_icon.png": 78977,
	"./vip.png": 84850,
	"./vip_icon.png": 47644
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98200;